export default {
    data() {
        return {
            isBuilderDev: false,
            view: null
        }
    },
    created() {
        this.isBuilderDev = window.builder_dev_mode
    },
    mounted() {
        if (this.isBuilderDev) {
            const view = document.querySelector(".widget-view")
            if (view) {
                this.view = view
            }
        }
    },
    methods: {
        resolveStyle(desktop, mobile) {
            if (!this.isBuilderDev) {
                return window.innerWidth > 640 ? desktop : mobile
            } else {
                if (!this.view) {
                    return desktop
                }
                const { width } = this.view.getBoundingClientRect()
                return width > 640 ? desktop : mobile
            }
        }
    }
}
